module.exports = __webpack_public_path__ + "static/media/estimate_preview_en.2e8610ac.png";